<main class="newPassword">
  <header>
    <img
      class="newPassword--logo"
      src="../../../../assets/logos/seat-cupra-logo-white.svg"
      alt="{{ 'altUser' }}"
    />
  </header>
  <section class="main">
    <h2 class="main--title">{{ 'newPasswordTitle' | i18next }}</h2>
    <form [formGroup]="formPassword" class="form">
      <div class="form--codeContainer">
        <span
          >{{ 'emailVerificationText' | i18next }}
          {{ 'emailVerificationResendCodeText' | i18next }}
          <button
            type="button"
            class="form--codeContainer__btn"
            (click)="resendCode()"
          >
            {{ 'emailVerificationResendCodeBtn' | i18next | uppercase }}
          </button>
        </span>
        <span *ngIf="resendCodeText">
          <p class="form--codeContainer__text">{{ resendCodeText }}</p>
        </span>
        <mat-form-field class="form--input">
          <mat-label for="code">{{ 'code' | i18next }}</mat-label>
          <input matInput type="text" formControlName="code" #autofocus />
        </mat-form-field>
        <span *ngIf="controlInput('code')" class="errorMessage">
          {{ 'inputInvalid' | i18next }}
        </span>
      </div>
      <div class="form--passwordsContainer">
        <mat-form-field class="form--input">
          <mat-label for="password">{{ 'newPassword' | i18next }}</mat-label>
          <input matInput type="password" formControlName="password" />
        </mat-form-field>
        <mat-form-field class="form--input repeatPassword">
          <mat-label for="repeatPassword">{{
            'repeatPassword' | i18next
          }}</mat-label>
          <input
            matInput
            type="repeatPassword"
            type="password"
            formControlName="repeatPassword"
          />
        </mat-form-field>
      </div>
      <p [ngClass]="errorMsg('repeatPassword')" class="error-text text">
        {{ 'passwordPattern' | i18next }}
      </p>
      <span class="error-message"> {{ errorMessage }} </span>
      <div class="form--btnContainer">
        <button
          mat-button
          type="button"
          class="form--btnContainer__btnCancel btn cancel"
          [routerLink]="['/login']"
        >
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
        <button
          mat-button
          type="submit"
          class="form--btnContainer__btn btn confirmDark"
          (click)="onSubmit()"
          [disabled]="!formPassword.valid"
        >
          {{ 'btnAccept' | i18next | uppercase }}
        </button>
        <div class="text-center spinner-container" *ngIf="spinner">
          <div class="spinner-border spinner" role="status"></div>
        </div>
      </div>
    </form>
  </section>
</main>
